import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Button = ({ children, to, variant, ...props }) => {
  return (
    <StyledLink to={to} $variant={variant} {...props}>
      {children}
    </StyledLink>
  );
};

const StyledLink = styled(Link)`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;

  ${props => props.$variant === 'primary' && `
    background: ${props.theme.colors.primary};
    color: white;
    border: none;
    
    &:hover {
      background: ${props.theme.colors.background.purple};
    }
  `}

  ${props => props.$variant === 'outline' && `
    background: transparent;
    color: white;
    border: 2px solid white;
  `}
`;

export default Button; 